import { useMemo } from 'react';
import { Link, useLocation } from 'react-router';
import { Trans, useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useWindowSize } from 'react-easyrocket';
import { twJoin } from 'tailwind-merge';
import { Button } from 'src/components/Buttons/Button';
import { useDrawer } from 'src/hooks/useDrawer';
import { useRoute } from 'src/router/hooks';
import './styles.css';
import { useSettings } from 'src/modules/settings';

export const CookiesBanner = () => {
  const { isLeftDrawerOpen } = useDrawer();
  const { t } = useTranslation();
  const { is768 } = useWindowSize();
  const { pathname } = useLocation();
  const { setSettings, isCookiesAccepted } = useSettings();
  const onAcceptCookiesClick = () => {
    setSettings({ type: 'SET_COOKIES_ACCEPTED' });
  };
  const { ROUTE } = useRoute();

  const stickToBottom = useMemo(() => {
    const bottomRoutes = [
      { path: 'game/' },
      { path: 'welcome-bonus' },
      { path: '/404' },
      { path: 'account' }
    ];
    return is768 || bottomRoutes.some((route) => pathname.includes(route.path));
  }, [is768, pathname]);

  if (isCookiesAccepted) return null;

  return (
    <div
      className={twJoin(
        'cookie-banner-wrapper pointer-events-auto',
        isLeftDrawerOpen ? 'blured' : '',
        'fixed left-0 w-full',
        stickToBottom ? 'bottom-0' : 'bottom-[75px]',
        is768 ? 'fixed left-0 z-[600] w-full' : 'fixed z-[100] w-full'
      )}>
      <div className="content-wrapper">
        <p className={classNames('cookies-content flex-1')}>
          <Trans
            i18nKey="cookiesBanner.text"
            components={{
              1: (
                <Link
                  target="_blank"
                  to={ROUTE.INFO_PAGES_POLICY.get()}
                  className="font-bold cursor-pointer text-cb_link underline"
                />
              )
            }}
          />
        </p>
        <Button
          title="ok"
          mode="button-secondary"
          className="max-w-[60px] max-h-[30px]"
          onClick={onAcceptCookiesClick}>
          {t('cookiesBanner.ok')}
        </Button>
      </div>
    </div>
  );
};
